module.exports = __webpack_public_path__ + "img/ideas.45911d13.svg";